<div class="page-heading">
    <div class="container sub-container">
        <div class="row" *ngIf="children.length > 1">
            <ul class="row">  
                <ng-container *ngFor="let item of children">
                    <ng-container *ngIf="(item.data.menuYn == 'Y' && (item.data.loginYn == 'A' || (isLogined && item.data.loginYn == 'Y') || (!isLogined && item.data.loginYn == 'N')))">
                        <ng-container *ngIf="userKind == '00' && item.data.consumerYn == 'Y'">
                            <li  class="col-auto menu-item "
                            [ngClass]="pathname == item.data.linkInfo ? 'active' : ''"
                            >
                                <a [routerLink]="item.data.linkInfo">
                                    {{ item.data.prgName }}
                                </a>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="userKind != '00'">
                            <li class="col-auto menu-item "
                            [ngClass]="pathname == item.data.linkInfo ? 'active' : ''">
                                <a [routerLink]="item.data.linkInfo">
                                    {{ item.data.prgName }}
                                </a>
                            </li>
                        </ng-container>
                    </ng-container>
                </ng-container>         
            </ul>
        </div>
    </div>
</div>
